module.exports = __webpack_public_path__ + "static/media/ggj2018.83328afc.png";